import type { ExposeInterface } from './types';

//TODO: We need to think about moving this store to the Accoutn store
export const useUserInfoStore = defineStore('UserInfo', (): ExposeInterface => {
    const sessionID: Ref<string | null> = ref(null);
    const login: Ref<string | null> = ref(null);
    const password: Ref<string | null> = ref(null); // TODO: looks like as extra field, need to check if it is used in the application


    /**
     * Getter to check if the user is logged in as guest
     * @returns {boolean} true if the user is logged in as guest and false if the user is not logged in or logged in as client
     */
    const isGuest = computed((): boolean => sessionID.value === null);
    /**
     * Getter to check if the user is logged in as client
     * @returns {boolean} true if the user is logged in as client and false if the user is not logged in or logged in as guest
     */
    const isClient = computed((): boolean => sessionID.value !== null);
    /**
     * Get user login
     * @returns {boolean} true if the service is available and false otherwise
     */
    const getUserLogin = computed((): string | null => login.value);

    const setLogin = (value: string | null) => {
        login.value = value;
    };

    const setSessionID = (value: string | null) => {
        sessionID.value = value;
    };

    const setPassword = (value: string | null) => {
        password.value = value;
    };

    const userEmail: Ref<string | null> = ref(null);
    const setUserEmail = (value: string | null) => {
        userEmail.value = value;
    };
    const getUserEmail = computed((): string | null => userEmail.value);

    const setToInitialState = () => {
        sessionID.value = null;
        login.value = null;
        password.value = null;
        userEmail.value = null;
    };
        
  return { 
        isGuest,
        isClient,
        getUserLogin,
        setLogin,
        setSessionID,
        setPassword,
        setToInitialState,
        setUserEmail,
        getUserEmail
   };
});
